import { render } from "./News.vue?vue&type=template&id=657a6509"
import script from "./News.vue?vue&type=script&lang=js"
export * from "./News.vue?vue&type=script&lang=js"

import "./News.vue?vue&type=style&index=0&id=657a6509&lang=css"
script.render = render

export default script